import React, {useEffect, useMemo, useState} from 'react';
import {useSelector} from 'react-redux';
import View from './View';
import {getFormValues} from 'redux-form';
import {Forms} from '../../../../shared/models/forms';
import {SearchBarForm} from '../../SearchBar/model';
import {Platform} from 'react-native';
import {HistoryCardsListProps} from '../model';

const paginationSize = Platform.OS === 'web' ? 12 : 5;

export const HistoryCardsList = ({data}: HistoryCardsListProps) => {
  const searchHistoryQuery = useSelector(getFormValues(Forms.searchBarForm)) as SearchBarForm;
  const [visibleElementsCount, setVisibleElementsCount] = useState(paginationSize);
  const [searchedHistory, setSearchedHistory] = useState(data);

  const canShowMore = useMemo(() => (data?.length || 0) > visibleElementsCount, [data, visibleElementsCount]);

  useEffect(() => {
    if (!searchHistoryQuery && data) {
      setSearchedHistory(data);
    }
    if (searchHistoryQuery?.query && data) {
      const searchQuery = searchHistoryQuery.query.toLowerCase();
      setSearchedHistory(() => {
        const filteredVisibleHistory = data.filter((item) => {
          if (item.operationName?.toLowerCase().includes(searchQuery)) return item;
        });
        return filteredVisibleHistory;
      });
    }
  }, [searchHistoryQuery, data]);

  const visibledata = searchedHistory ? searchedHistory.slice(0, visibleElementsCount) ?? [] : null;

  return (
    <View
      data={visibledata}
      onShowMore={() => setVisibleElementsCount(visibleElementsCount + paginationSize)}
      canShowMore={canShowMore}
    />
  );
};
